/**
 * Data libur nasional & cuti bersama Indonesia 2020-2030.
 * Sumber: SKB 3 Menteri (Menag, Menaker, Menpan-RB) tahun terkait.
 * Tahun 2028-2030 adalah perkiraan (libur keagamaan tetap bisa bergeser).
 * Catatan: data dapat diperbarui jika SKB resmi berubah.
 */

export type HolidayType = "libur" | "cuti-bersama";
export type HolidayCategory = "keagamaan" | "nasional" | "internasional";

export interface Holiday {
  /** ISO date YYYY-MM-DD */
  date: string;
  name: string;
  type: HolidayType;
  category: HolidayCategory;
}

const _2020: Holiday[] = [
  { date: "2020-01-01", name: "Tahun Baru Masehi", type: "libur", category: "nasional" },
  { date: "2020-01-25", name: "Tahun Baru Imlek 2571", type: "libur", category: "keagamaan" },
  { date: "2020-03-22", name: "Isra Mikraj Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2020-03-25", name: "Hari Raya Nyepi (Tahun Baru Saka 1942)", type: "libur", category: "keagamaan" },
  { date: "2020-04-10", name: "Wafat Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2020-05-01", name: "Hari Buruh Internasional", type: "libur", category: "nasional" },
  { date: "2020-05-07", name: "Hari Raya Waisak 2564", type: "libur", category: "keagamaan" },
  { date: "2020-05-21", name: "Kenaikan Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2020-05-24", name: "Hari Raya Idul Fitri 1441 H", type: "libur", category: "keagamaan" },
  { date: "2020-05-25", name: "Hari Raya Idul Fitri 1441 H", type: "libur", category: "keagamaan" },
  { date: "2020-06-01", name: "Hari Lahir Pancasila", type: "libur", category: "nasional" },
  { date: "2020-07-31", name: "Hari Raya Idul Adha 1441 H", type: "libur", category: "keagamaan" },
  { date: "2020-08-17", name: "Hari Kemerdekaan RI", type: "libur", category: "nasional" },
  { date: "2020-08-20", name: "Tahun Baru Islam 1442 H", type: "libur", category: "keagamaan" },
  { date: "2020-10-29", name: "Maulid Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2020-12-25", name: "Hari Raya Natal", type: "libur", category: "keagamaan" },
  { date: "2020-08-21", name: "Cuti Bersama Tahun Baru Islam", type: "cuti-bersama", category: "keagamaan" },
  { date: "2020-10-28", name: "Cuti Bersama Maulid Nabi", type: "cuti-bersama", category: "keagamaan" },
  { date: "2020-10-30", name: "Cuti Bersama Maulid Nabi", type: "cuti-bersama", category: "keagamaan" },
  { date: "2020-12-24", name: "Cuti Bersama Natal", type: "cuti-bersama", category: "keagamaan" },
  { date: "2020-12-31", name: "Cuti Bersama Akhir Tahun", type: "cuti-bersama", category: "nasional" },
];

const _2021: Holiday[] = [
  { date: "2021-01-01", name: "Tahun Baru Masehi", type: "libur", category: "nasional" },
  { date: "2021-02-12", name: "Tahun Baru Imlek 2572", type: "libur", category: "keagamaan" },
  { date: "2021-03-11", name: "Isra Mikraj Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2021-03-14", name: "Hari Raya Nyepi (Tahun Baru Saka 1943)", type: "libur", category: "keagamaan" },
  { date: "2021-04-02", name: "Wafat Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2021-05-01", name: "Hari Buruh Internasional", type: "libur", category: "nasional" },
  { date: "2021-05-13", name: "Kenaikan Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2021-05-13", name: "Hari Raya Idul Fitri 1442 H", type: "libur", category: "keagamaan" },
  { date: "2021-05-14", name: "Hari Raya Idul Fitri 1442 H", type: "libur", category: "keagamaan" },
  { date: "2021-05-26", name: "Hari Raya Waisak 2565", type: "libur", category: "keagamaan" },
  { date: "2021-06-01", name: "Hari Lahir Pancasila", type: "libur", category: "nasional" },
  { date: "2021-07-20", name: "Hari Raya Idul Adha 1442 H", type: "libur", category: "keagamaan" },
  { date: "2021-08-10", name: "Tahun Baru Islam 1443 H", type: "libur", category: "keagamaan" },
  { date: "2021-08-17", name: "Hari Kemerdekaan RI", type: "libur", category: "nasional" },
  { date: "2021-10-19", name: "Maulid Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2021-12-24", name: "Cuti Bersama Natal", type: "cuti-bersama", category: "keagamaan" },
  { date: "2021-12-25", name: "Hari Raya Natal", type: "libur", category: "keagamaan" },
];

const _2022: Holiday[] = [
  { date: "2022-01-01", name: "Tahun Baru Masehi", type: "libur", category: "nasional" },
  { date: "2022-02-01", name: "Tahun Baru Imlek 2573", type: "libur", category: "keagamaan" },
  { date: "2022-02-28", name: "Isra Mikraj Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2022-03-03", name: "Hari Raya Nyepi (Tahun Baru Saka 1944)", type: "libur", category: "keagamaan" },
  { date: "2022-04-15", name: "Wafat Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2022-05-01", name: "Hari Buruh Internasional", type: "libur", category: "nasional" },
  { date: "2022-05-02", name: "Hari Raya Idul Fitri 1443 H", type: "libur", category: "keagamaan" },
  { date: "2022-05-03", name: "Hari Raya Idul Fitri 1443 H", type: "libur", category: "keagamaan" },
  { date: "2022-05-04", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2022-05-05", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2022-05-06", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2022-05-16", name: "Hari Raya Waisak 2566", type: "libur", category: "keagamaan" },
  { date: "2022-05-26", name: "Kenaikan Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2022-06-01", name: "Hari Lahir Pancasila", type: "libur", category: "nasional" },
  { date: "2022-07-09", name: "Hari Raya Idul Adha 1443 H", type: "libur", category: "keagamaan" },
  { date: "2022-07-30", name: "Tahun Baru Islam 1444 H", type: "libur", category: "keagamaan" },
  { date: "2022-08-17", name: "Hari Kemerdekaan RI", type: "libur", category: "nasional" },
  { date: "2022-10-08", name: "Maulid Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2022-12-25", name: "Hari Raya Natal", type: "libur", category: "keagamaan" },
  { date: "2022-12-26", name: "Cuti Bersama Natal", type: "cuti-bersama", category: "keagamaan" },
];

const _2023: Holiday[] = [
  { date: "2023-01-01", name: "Tahun Baru Masehi", type: "libur", category: "nasional" },
  { date: "2023-01-22", name: "Tahun Baru Imlek 2574", type: "libur", category: "keagamaan" },
  { date: "2023-01-23", name: "Cuti Bersama Imlek", type: "cuti-bersama", category: "keagamaan" },
  { date: "2023-02-18", name: "Isra Mikraj Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2023-03-22", name: "Hari Raya Nyepi (Tahun Baru Saka 1945)", type: "libur", category: "keagamaan" },
  { date: "2023-03-23", name: "Cuti Bersama Nyepi", type: "cuti-bersama", category: "keagamaan" },
  { date: "2023-04-07", name: "Wafat Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2023-04-19", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2023-04-20", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2023-04-21", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2023-04-22", name: "Hari Raya Idul Fitri 1444 H", type: "libur", category: "keagamaan" },
  { date: "2023-04-23", name: "Hari Raya Idul Fitri 1444 H", type: "libur", category: "keagamaan" },
  { date: "2023-04-24", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2023-04-25", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2023-05-01", name: "Hari Buruh Internasional", type: "libur", category: "nasional" },
  { date: "2023-05-18", name: "Kenaikan Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2023-06-01", name: "Hari Lahir Pancasila", type: "libur", category: "nasional" },
  { date: "2023-06-02", name: "Cuti Bersama Hari Lahir Pancasila", type: "cuti-bersama", category: "nasional" },
  { date: "2023-06-04", name: "Hari Raya Waisak 2567", type: "libur", category: "keagamaan" },
  { date: "2023-06-29", name: "Hari Raya Idul Adha 1444 H", type: "libur", category: "keagamaan" },
  { date: "2023-07-19", name: "Tahun Baru Islam 1445 H", type: "libur", category: "keagamaan" },
  { date: "2023-08-17", name: "Hari Kemerdekaan RI", type: "libur", category: "nasional" },
  { date: "2023-09-28", name: "Maulid Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2023-12-25", name: "Hari Raya Natal", type: "libur", category: "keagamaan" },
  { date: "2023-12-26", name: "Cuti Bersama Natal", type: "cuti-bersama", category: "keagamaan" },
];

const _2024: Holiday[] = [
  { date: "2024-01-01", name: "Tahun Baru Masehi", type: "libur", category: "nasional" },
  { date: "2024-02-08", name: "Isra Mikraj Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2024-02-09", name: "Cuti Bersama Imlek", type: "cuti-bersama", category: "keagamaan" },
  { date: "2024-02-10", name: "Tahun Baru Imlek 2575", type: "libur", category: "keagamaan" },
  { date: "2024-03-11", name: "Hari Raya Nyepi (Tahun Baru Saka 1946)", type: "libur", category: "keagamaan" },
  { date: "2024-03-12", name: "Cuti Bersama Nyepi", type: "cuti-bersama", category: "keagamaan" },
  { date: "2024-03-29", name: "Wafat Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2024-03-31", name: "Hari Paskah", type: "libur", category: "keagamaan" },
  { date: "2024-04-08", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2024-04-09", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2024-04-10", name: "Hari Raya Idul Fitri 1445 H", type: "libur", category: "keagamaan" },
  { date: "2024-04-11", name: "Hari Raya Idul Fitri 1445 H", type: "libur", category: "keagamaan" },
  { date: "2024-04-12", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2024-04-15", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2024-05-01", name: "Hari Buruh Internasional", type: "libur", category: "nasional" },
  { date: "2024-05-09", name: "Kenaikan Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2024-05-10", name: "Cuti Bersama Kenaikan Isa Almasih", type: "cuti-bersama", category: "keagamaan" },
  { date: "2024-05-23", name: "Hari Raya Waisak 2568", type: "libur", category: "keagamaan" },
  { date: "2024-05-24", name: "Cuti Bersama Waisak", type: "cuti-bersama", category: "keagamaan" },
  { date: "2024-06-01", name: "Hari Lahir Pancasila", type: "libur", category: "nasional" },
  { date: "2024-06-17", name: "Hari Raya Idul Adha 1445 H", type: "libur", category: "keagamaan" },
  { date: "2024-06-18", name: "Cuti Bersama Idul Adha", type: "cuti-bersama", category: "keagamaan" },
  { date: "2024-07-07", name: "Tahun Baru Islam 1446 H", type: "libur", category: "keagamaan" },
  { date: "2024-08-17", name: "Hari Kemerdekaan RI", type: "libur", category: "nasional" },
  { date: "2024-09-16", name: "Maulid Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2024-12-25", name: "Hari Raya Natal", type: "libur", category: "keagamaan" },
  { date: "2024-12-26", name: "Cuti Bersama Natal", type: "cuti-bersama", category: "keagamaan" },
];

const _2025: Holiday[] = [
  { date: "2025-01-01", name: "Tahun Baru Masehi", type: "libur", category: "nasional" },
  { date: "2025-01-27", name: "Cuti Bersama Imlek", type: "cuti-bersama", category: "keagamaan" },
  { date: "2025-01-29", name: "Tahun Baru Imlek 2576", type: "libur", category: "keagamaan" },
  { date: "2025-03-28", name: "Cuti Bersama Nyepi", type: "cuti-bersama", category: "keagamaan" },
  { date: "2025-03-29", name: "Hari Raya Nyepi (Tahun Baru Saka 1947)", type: "libur", category: "keagamaan" },
  { date: "2025-03-31", name: "Hari Raya Idul Fitri 1446 H", type: "libur", category: "keagamaan" },
  { date: "2025-04-01", name: "Hari Raya Idul Fitri 1446 H", type: "libur", category: "keagamaan" },
  { date: "2025-04-02", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2025-04-03", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2025-04-04", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2025-04-07", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2025-04-18", name: "Wafat Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2025-04-20", name: "Hari Paskah", type: "libur", category: "keagamaan" },
  { date: "2025-05-01", name: "Hari Buruh Internasional", type: "libur", category: "nasional" },
  { date: "2025-05-12", name: "Hari Raya Waisak 2569", type: "libur", category: "keagamaan" },
  { date: "2025-05-13", name: "Cuti Bersama Waisak", type: "cuti-bersama", category: "keagamaan" },
  { date: "2025-05-29", name: "Kenaikan Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2025-05-30", name: "Cuti Bersama Kenaikan Isa Almasih", type: "cuti-bersama", category: "keagamaan" },
  { date: "2025-06-01", name: "Hari Lahir Pancasila", type: "libur", category: "nasional" },
  { date: "2025-06-06", name: "Hari Raya Idul Adha 1446 H", type: "libur", category: "keagamaan" },
  { date: "2025-06-09", name: "Cuti Bersama Idul Adha", type: "cuti-bersama", category: "keagamaan" },
  { date: "2025-06-27", name: "Tahun Baru Islam 1447 H", type: "libur", category: "keagamaan" },
  { date: "2025-08-17", name: "Hari Kemerdekaan RI", type: "libur", category: "nasional" },
  { date: "2025-09-05", name: "Maulid Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2025-12-25", name: "Hari Raya Natal", type: "libur", category: "keagamaan" },
  { date: "2025-12-26", name: "Cuti Bersama Natal", type: "cuti-bersama", category: "keagamaan" },
];

const _2026: Holiday[] = [
  { date: "2026-01-01", name: "Tahun Baru Masehi", type: "libur", category: "nasional" },
  { date: "2026-01-15", name: "Isra Mikraj Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2026-02-16", name: "Cuti Bersama Tahun Baru Imlek", type: "cuti-bersama", category: "keagamaan" },
  { date: "2026-02-17", name: "Tahun Baru Imlek 2577", type: "libur", category: "keagamaan" },
  { date: "2026-03-18", name: "Cuti Bersama Hari Suci Nyepi", type: "cuti-bersama", category: "keagamaan" },
  { date: "2026-03-19", name: "Hari Raya Nyepi (Tahun Baru Saka 1948)", type: "libur", category: "keagamaan" },
  { date: "2026-03-20", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2026-03-20", name: "Hari Raya Idul Fitri 1447 H", type: "libur", category: "keagamaan" },
  { date: "2026-03-21", name: "Hari Raya Idul Fitri 1447 H", type: "libur", category: "keagamaan" },
  { date: "2026-03-23", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2026-03-24", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2026-04-03", name: "Wafat Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2026-04-05", name: "Kebangkitan Yesus Kristus (Paskah)", type: "libur", category: "keagamaan" },
  { date: "2026-05-01", name: "Hari Buruh Internasional", type: "libur", category: "nasional" },
  { date: "2026-05-14", name: "Kenaikan Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2026-05-15", name: "Cuti Bersama Kenaikan Isa Almasih", type: "cuti-bersama", category: "keagamaan" },
  { date: "2026-05-27", name: "Hari Raya Idul Adha 1447 H", type: "libur", category: "keagamaan" },
  { date: "2026-05-28", name: "Cuti Bersama Idul Adha", type: "cuti-bersama", category: "keagamaan" },
  { date: "2026-05-31", name: "Hari Raya Waisak 2570", type: "libur", category: "keagamaan" },
  { date: "2026-06-01", name: "Hari Lahir Pancasila", type: "libur", category: "nasional" },
  { date: "2026-06-16", name: "Tahun Baru Islam 1448 H", type: "libur", category: "keagamaan" },
  { date: "2026-08-17", name: "Hari Kemerdekaan RI", type: "libur", category: "nasional" },
  { date: "2026-08-25", name: "Maulid Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2026-12-24", name: "Cuti Bersama Natal", type: "cuti-bersama", category: "keagamaan" },
  { date: "2026-12-25", name: "Hari Raya Natal", type: "libur", category: "keagamaan" },
];

const _2027: Holiday[] = [
  { date: "2027-01-01", name: "Tahun Baru Masehi", type: "libur", category: "nasional" },
  { date: "2027-01-05", name: "Isra Mikraj Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2027-02-05", name: "Cuti Bersama Tahun Baru Imlek", type: "cuti-bersama", category: "keagamaan" },
  { date: "2027-02-06", name: "Tahun Baru Imlek 2578", type: "libur", category: "keagamaan" },
  { date: "2027-03-08", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2027-03-09", name: "Hari Raya Idul Fitri 1448 H", type: "libur", category: "keagamaan" },
  { date: "2027-03-10", name: "Hari Raya Idul Fitri 1448 H", type: "libur", category: "keagamaan" },
  { date: "2027-03-11", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2027-03-12", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2027-03-26", name: "Wafat Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2027-04-07", name: "Cuti Bersama Hari Suci Nyepi", type: "cuti-bersama", category: "keagamaan" },
  { date: "2027-04-08", name: "Hari Raya Nyepi (Tahun Baru Saka 1949)", type: "libur", category: "keagamaan" },
  { date: "2027-05-01", name: "Hari Buruh Internasional", type: "libur", category: "nasional" },
  { date: "2027-05-06", name: "Kenaikan Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2027-05-07", name: "Cuti Bersama Kenaikan Isa Almasih", type: "cuti-bersama", category: "keagamaan" },
  { date: "2027-05-17", name: "Hari Raya Idul Adha 1448 H", type: "libur", category: "keagamaan" },
  { date: "2027-05-18", name: "Cuti Bersama Idul Adha", type: "cuti-bersama", category: "keagamaan" },
  { date: "2027-05-20", name: "Hari Raya Waisak 2571", type: "libur", category: "keagamaan" },
  { date: "2027-05-21", name: "Cuti Bersama Waisak", type: "cuti-bersama", category: "keagamaan" },
  { date: "2027-06-01", name: "Hari Lahir Pancasila", type: "libur", category: "nasional" },
  { date: "2027-06-06", name: "Tahun Baru Islam 1449 H", type: "libur", category: "keagamaan" },
  { date: "2027-08-15", name: "Maulid Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2027-08-17", name: "Hari Kemerdekaan RI", type: "libur", category: "nasional" },
  { date: "2027-12-24", name: "Cuti Bersama Natal", type: "cuti-bersama", category: "keagamaan" },
  { date: "2027-12-25", name: "Hari Raya Natal", type: "libur", category: "keagamaan" },
];

const _2028: Holiday[] = [
  { date: "2028-01-01", name: "Tahun Baru Masehi", type: "libur", category: "nasional" },
  { date: "2028-01-25", name: "Cuti Bersama Tahun Baru Imlek", type: "cuti-bersama", category: "keagamaan" },
  { date: "2028-01-26", name: "Tahun Baru Imlek 2579", type: "libur", category: "keagamaan" },
  { date: "2028-02-25", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2028-02-26", name: "Hari Raya Idul Fitri 1449 H", type: "libur", category: "keagamaan" },
  { date: "2028-02-27", name: "Hari Raya Idul Fitri 1449 H", type: "libur", category: "keagamaan" },
  { date: "2028-02-28", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2028-02-29", name: "Cuti Bersama Idul Fitri", type: "cuti-bersama", category: "keagamaan" },
  { date: "2028-03-27", name: "Hari Raya Nyepi (Tahun Baru Saka 1950)", type: "libur", category: "keagamaan" },
  { date: "2028-04-14", name: "Wafat Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2028-05-01", name: "Hari Buruh Internasional", type: "libur", category: "nasional" },
  { date: "2028-05-05", name: "Hari Raya Idul Adha 1449 H", type: "libur", category: "keagamaan" },
  { date: "2028-05-09", name: "Hari Raya Waisak 2572", type: "libur", category: "keagamaan" },
  { date: "2028-05-25", name: "Kenaikan Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2028-06-01", name: "Hari Lahir Pancasila", type: "libur", category: "nasional" },
  { date: "2028-08-04", name: "Maulid Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2028-08-17", name: "Hari Kemerdekaan RI", type: "libur", category: "nasional" },
  { date: "2028-12-26", name: "Cuti Bersama Natal", type: "cuti-bersama", category: "keagamaan" },
  { date: "2028-12-25", name: "Hari Raya Natal", type: "libur", category: "keagamaan" },
];

const _2029: Holiday[] = [
  { date: "2029-01-01", name: "Tahun Baru Masehi", type: "libur", category: "nasional" },
  { date: "2029-02-13", name: "Tahun Baru Imlek 2580", type: "libur", category: "keagamaan" },
  { date: "2029-02-14", name: "Hari Raya Idul Fitri 1450 H", type: "libur", category: "keagamaan" },
  { date: "2029-02-15", name: "Hari Raya Idul Fitri 1450 H", type: "libur", category: "keagamaan" },
  { date: "2029-03-16", name: "Hari Raya Nyepi (Tahun Baru Saka 1951)", type: "libur", category: "keagamaan" },
  { date: "2029-03-30", name: "Wafat Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2029-04-24", name: "Hari Raya Idul Adha 1450 H", type: "libur", category: "keagamaan" },
  { date: "2029-04-27", name: "Hari Raya Waisak 2573", type: "libur", category: "keagamaan" },
  { date: "2029-05-01", name: "Hari Buruh Internasional", type: "libur", category: "nasional" },
  { date: "2029-05-10", name: "Kenaikan Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2029-06-01", name: "Hari Lahir Pancasila", type: "libur", category: "nasional" },
  { date: "2029-07-25", name: "Maulid Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2029-08-17", name: "Hari Kemerdekaan RI", type: "libur", category: "nasional" },
  { date: "2029-12-25", name: "Hari Raya Natal", type: "libur", category: "keagamaan" },
];

const _2030: Holiday[] = [
  { date: "2030-01-01", name: "Tahun Baru Masehi", type: "libur", category: "nasional" },
  { date: "2030-02-03", name: "Tahun Baru Imlek 2581", type: "libur", category: "keagamaan" },
  { date: "2030-02-04", name: "Hari Raya Idul Fitri 1451 H", type: "libur", category: "keagamaan" },
  { date: "2030-02-05", name: "Hari Raya Idul Fitri 1451 H", type: "libur", category: "keagamaan" },
  { date: "2030-03-05", name: "Hari Raya Nyepi (Tahun Baru Saka 1952)", type: "libur", category: "keagamaan" },
  { date: "2030-04-13", name: "Hari Raya Idul Adha 1451 H", type: "libur", category: "keagamaan" },
  { date: "2030-04-19", name: "Wafat Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2030-05-01", name: "Hari Buruh Internasional", type: "libur", category: "nasional" },
  { date: "2030-05-16", name: "Hari Raya Waisak 2574", type: "libur", category: "keagamaan" },
  { date: "2030-05-30", name: "Kenaikan Isa Almasih", type: "libur", category: "keagamaan" },
  { date: "2030-06-01", name: "Hari Lahir Pancasila", type: "libur", category: "nasional" },
  { date: "2030-07-15", name: "Maulid Nabi Muhammad SAW", type: "libur", category: "keagamaan" },
  { date: "2030-08-17", name: "Hari Kemerdekaan RI", type: "libur", category: "nasional" },
  { date: "2030-12-25", name: "Hari Raya Natal", type: "libur", category: "keagamaan" },
];

// ---- 2031–2034: PERKIRAAN. Hanya libur Gregorian tetap (Tahun Baru,
// Pancasila, Kemerdekaan RI, Natal). Libur keagamaan menanti SKB resmi
// dan akan ditambahkan menjelang tahun terkait. Halaman tahun terkait
// menampilkan disclaimer "perkiraan" via isEstimatedYear().
function fixedGregorian(y: number): Holiday[] {
  return [
    { date: `${y}-01-01`, name: "Tahun Baru Masehi", type: "libur", category: "nasional" },
    { date: `${y}-05-01`, name: "Hari Buruh Internasional", type: "libur", category: "nasional" },
    { date: `${y}-06-01`, name: "Hari Lahir Pancasila", type: "libur", category: "nasional" },
    { date: `${y}-08-17`, name: "Hari Kemerdekaan RI", type: "libur", category: "nasional" },
    { date: `${y}-12-25`, name: "Hari Raya Natal", type: "libur", category: "keagamaan" },
  ];
}
const _2031: Holiday[] = fixedGregorian(2031);
const _2032: Holiday[] = fixedGregorian(2032);
const _2033: Holiday[] = fixedGregorian(2033);
const _2034: Holiday[] = fixedGregorian(2034);

export const HOLIDAYS_BY_YEAR: Record<number, Holiday[]> = {
  2020: _2020,
  2021: _2021,
  2022: _2022,
  2023: _2023,
  2024: _2024,
  2025: _2025,
  2026: _2026,
  2027: _2027,
  2028: _2028,
  2029: _2029,
  2030: _2030,
  2031: _2031,
  2032: _2032,
  2033: _2033,
  2034: _2034,
};

export const SUPPORTED_YEARS = Object.keys(HOLIDAYS_BY_YEAR)
  .map((y) => parseInt(y, 10))
  .sort((a, b) => a - b);

export const MIN_YEAR = SUPPORTED_YEARS[0];
export const MAX_YEAR = SUPPORTED_YEARS[SUPPORTED_YEARS.length - 1];

export function getHolidaysForYear(year: number): Holiday[] {
  return HOLIDAYS_BY_YEAR[year] ?? [];
}

export function getHolidaysForMonth(year: number, month: number): Holiday[] {
  // month: 1-12
  const m = month.toString().padStart(2, "0");
  return getHolidaysForYear(year).filter((h) => h.date.startsWith(`${year}-${m}`));
}

export function getHolidaysForDate(dateISO: string): Holiday[] {
  const year = parseInt(dateISO.slice(0, 4), 10);
  return getHolidaysForYear(year).filter((h) => h.date === dateISO);
}

/** Estimated note for years where the SKB may not yet be official. */
export function isEstimatedYear(year: number): boolean {
  return year >= 2028;
}

/** Years where ONLY fixed Gregorian holidays are populated (2031+). */
export function isPlaceholderYear(year: number): boolean {
  return year >= 2031;
}

/** Disclaimer used in PDFs and on libur pages. */
export const DISCLAIMER_SKB =
  "Data libur nasional & cuti bersama bersumber dari SKB 3 Menteri (Menag, Menaker, Menpan-RB) tahun terkait. Untuk tahun yang SKB-nya belum terbit, data bersifat perkiraan dan dapat berubah. Pastikan verifikasi ulang untuk keperluan resmi.";

/** Map nama libur panjang → singkatan untuk tampilan kalender ringkas. */
const SHORT_NAMES: Array<[RegExp, string]> = [
  [/Hari Buruh Internasional/i, "Hari Buruh"],
  [/Hari Raya Idul Fitri.*/i, "Idul Fitri"],
  [/Hari Raya Idul Adha.*/i, "Idul Adha"],
  [/Hari Raya Nyepi.*/i, "Nyepi"],
  [/Hari Raya Waisak.*/i, "Waisak"],
  [/Hari Raya Natal/i, "Natal"],
  [/Tahun Baru Masehi/i, "Tahun Baru"],
  [/Tahun Baru Imlek.*/i, "Imlek"],
  [/Tahun Baru Islam.*/i, "Tahun Baru Islam"],
  [/Isra Mikraj.*/i, "Isra Mikraj"],
  [/Maulid Nabi.*/i, "Maulid Nabi"],
  [/Wafat Isa Almasih/i, "Wafat Isa Almasih"],
  [/Kenaikan Isa Almasih/i, "Kenaikan Isa"],
  [/Hari Lahir Pancasila/i, "Hari Pancasila"],
  [/Hari Kemerdekaan RI/i, "Kemerdekaan RI"],
  [/Cuti Bersama (.+)/i, "Cuti $1"],
];

export function shortenHoliday(name: string): string {
  for (const [re, rep] of SHORT_NAMES) {
    if (re.test(name)) return name.replace(re, rep);
  }
  return name.length > 18 ? name.slice(0, 17) + "…" : name;
}